export default __webpack_public_path__ + "/image/peprmint-headerlogo-color1_ef56bee.svg";